<template>
  <b-container>
    <b-row class="justify-content-center">
      <b-col cols="12" lg="10">
        <div class="mobile-cc-events-title container p-0">
          <div class="cc-events-txt">
            <div>PAST EVENTS</div>
          </div>
          <div class="events-banner">
            <Advertisement
              :imgWidth="'100%'"
              :imgHeight="'auto'"
              :background="'white'"
              :banners="eventBanners"
              :controls="false"
            />
          </div>
          <br />
          <div class="all-events-btn-cont">
            <div>
              <router-link to="/cc-events">
                <button class="eventsArchive">CC Events</button>
              </router-link>
              <router-link to="/events-media-archive">
                <button class="eventsArchive">Event Media Archive</button>
              </router-link>
            </div>
          </div>
        </div>
        <div
          class="EventList"
          v-for="{
            id,
            event,
            award,
            banner,
            end_date,
            city,
            start_date,
            name,
            slug,
            event_subtitle
          } in events"
          :key="id"
        >
          <b-container class="bv-example-row">
            <div
              v-if="isMobileScreen"
              class="for-mobile-design"
              @click="getRoute(event, award, slug)"
            >
              <div class="event-name">{{ name }}</div>
              <b-img :src="banner"></b-img>
              <div class="event-info">
                <b>
                  {{ $formatDate.getUTCDate(start_date) }}
                  {{ $formatDate.getUTCMonth(start_date) }} -
                  {{ $formatDate.getUTCDate(end_date) }}
                  {{ $formatDate.getUTCMonth(end_date) }}
                  {{ $formatDate.getUTCYear(end_date) }}
                </b>
                <div class="event-city">{{ city }}</div>
              </div>
            </div>
            <b-row v-if="!isMobileScreen" class="single-event">
              <b-col sm="1" class="event-year">{{
                $formatDate.getUTCYear(start_date)
              }}</b-col>
              <b-col sm="1" class="forEventDate">
                <p class="eventDate">
                  {{ $formatDate.getUTCDate(start_date) }}
                  {{ $formatDate.getUTCMonth(start_date) }}
                  <br />⌄<br />
                  {{ $formatDate.getUTCDate(end_date) }}
                  {{ $formatDate.getUTCMonth(end_date) }}
                </p>
              </b-col>

              <b-col sm="2" class="forEventImg">
                <b-img :src="banner"></b-img>
              </b-col>
              <b-col
                sm="3"
                class="forEventParaghraph"
                @click="getRoute(event, award, slug)"
              >
                <div class="eventTxt">{{ name }}</div>
                <div class="eventSubtitleTxt">{{ event_subtitle }}</div>
                <p class="eventCity">{{ city }}</p>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <b-container>
          <button v-if="nextPage" class="load-more" @click="loadMore">
            Load more events
          </button>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import Advertisement from "../../components/advertisement/Advertisement.vue";

export default {
  name: "PublicPastEvents",
  components: {
    Advertisement
  },
  data() {
    return {
      events: [],
      page: 1,
      nextPage: true,
      eventBanners: []
    };
  },
  async mounted() {
    await this.getEvents();
    await this.fetchAdvertisementBanners("event").then(
      res => (this.eventBanners = res)
    );
  },
  computed: {
    ...mapGetters({
      isMobileScreen: "isMobileScreen"
    })
  },
  methods: {
    ...mapActions({
      fetchPastEvents: "events/fetchPastEvents",
      fetchAdvertisementBanners: "advertisement/fetchAdvertisementBanners"
    }),
    moment(date) {
      return moment(new Date(date).toUTCString());
    },
    eventMonths(start, end) {
      return (
        this.moment(start).format("MMM") === this.moment(end).format("MMM")
      );
    },
    eventDays(start, end) {
      let day = this.moment(start).format("DD");
      if (end && start !== end) {
        day = `${this.moment(start).format("DD")} - ${this.moment(end).format(
          "DD"
        )}`;
      }
      return day;
    },
    async loadMore() {
      await this.getEvents();
    },
    async getEvents() {
      const { next, results } = await this.fetchPastEvents(this.page);
      this.events = [...this.events, ...results];
      this.nextPage = !!next;
      this.page += 1;
    },
    getRoute(event, award, slug) {
      if (event) {
        this.$router.push({
          name: "PublicInfo",
          params: { eventId: event, slug }
        });
      } else if (award) {
        this.$router.push({
          name: "PublicAwardInfo",
          params: { awardId: award, slug: slug }
        });
      }
    }
  }
};
</script>

<style scoped src="./Events.css"></style>
<style scoped src="./PublicEvents.css"></style>
